<template>
  <div id="overlay" @click="createMainDataCancel" >
    <div id="content" @click="stopPropagation" >
      <h1>Create</h1>
      <div class="outline-vertical">
        <div class="block-vertical">
          <!-- val01 -->
          <div class="input-holder">
            <input class="inputText-common" type="text" placeholder="val01" v-model="val01" />
          </div>
          <!-- val02 -->
          <div class="input-holder">
            <input class="inputText-common" type="text" placeholder="val02" v-model="val02" />
          </div>
          <!-- val03 -->
          <div class="input-holder">
            <textarea class="textarea-common" placeholder="val03" v-model="val03" ></textarea>
          </div>
          <!-- val04 -->
          <div class="input-holder">
            <vue-tags-input class="textarea-common" placeholder="val04"
              v-model="tag"
              :tags="tags"
              :add-on-key="[13, ',']"
              :seperators="[',']"
              :autocomplete-items="tagsForAutoCompleteFiltered"
              @tags-changed="newTags => tags = newTags"
            />
          </div>
        </div>
        <div class="block-vertical">
          <div class="block-horizontal">
            <div class="button-holder">
              <button @click="createMainDataCancel" class="button-cancel" >cancel</button>
            </div>
            <div class="button-holder">
              <button @click="createMainDataFix()" class="button-normal" >create!!</button>
            </div>
          </div>
        </div>
        <div class="block-vertical">
          <div class="div-procMsg-normal" v-if="procMsgNormal" >{{ procMsgNormal }}</div>
          <div class="div-procMsg-attention" v-if="procMsgAttention" >{{ procMsgAttention }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// データモジュール
import { MyData } from '@/my-modules/my-data'
// タグ機能モジュール(Vue Tags Input)
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'ModalCreate',

  components: {
    VueTagsInput
  },

  props: ['modalTagsForAutoComplete'],

  data: function () {
    return {
      val01: '',
      val02: '',
      val03: '',
      val04: '',
      tag: '',
      tags: [],
      tagsForAutoComplete: [],
      idToken: '',
      procMsgNormal: null,
      procMsgAttention: null
    }
  },

  mounted: function () {
    this.tagsForAutoComplete = this.modalTagsForAutoComplete
  },

  methods: {
    /* =================================================================================
     * stopPropagation
     *   モーダル背景のクリックイベントがdiv階層内に伝播しないようにする
     * ============================================================================== */
    stopPropagation () {
      event.stopPropagation()
    },

    /* =================================================================================
     * checkSession
     *   認証セッションの状態をチェック
     * ============================================================================== */
    async checkSession () {
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: Start', mc.LOG_TYPE_I) : (() => { })()
      try {
        const myAuth = new MyAuth()
        const res = await myAuth.checkSession()
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: OK', mc.LOG_TYPE_I) : (() => { })()
          this.idToken = res.content.idToken
          this.username = res.content.username
        } else if (res.status === 'NOAUTH') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: NOAUTH', mc.LOG_TYPE_I) : (() => { })()
          this.WriteProcMsg('normal', res.content)
        }
      // モジュールmyAuth(promise)からのrejectや例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=checkSession: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to check session at the moment, try back later.')
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * createMainDataCancel
     *   メインデータ追加処理を中止する
     * ============================================================================== */
    createMainDataCancel () {
      this.$emit('modalCanceled')
    },

    /* =================================================================================
     * createMainDataFix
     *   メインデータ追加処理を実行する
     * ============================================================================== */
    async createMainDataFix () {
      mc.LOG_LEVEL ? console.log('%c info: Method=createMainDataFix: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      if (this.val01 === '') {
        return false
      }
      // 下記は登録対象データの新IDをローカルのVue上のデータを元に採番するロジック
      // いまはdynamoDBのsequenceテーブルを元にlambdaがIDを採番するロジックにしているので下記ロジックは不要
      // let maxId = this.localMainData.reduce(function (a, b) {
      //   return a > b.id ? a : b.id
      // }, 0)
      // let newId = maxId + 1
      let strTags = ''
      if (this.tags) {
        const aryTags = []
        this.tags.forEach(item => { aryTags.push(item.text) })
        strTags = aryTags.join(',')
        if (strTags) {
          strTags = `,${strTags},`
        }
      }
      const itemForCreate = {
        // id: newId,
        val01: this.val01,
        val02: this.val02,
        val03: this.val03,
        val04: strTags
      }
      try {
        // 認証セッションの状態をチェック
        await this.checkSession()
        if (!this.idToken) { return false }
        const myData = new MyData()
        const res = await myData.createMainData(this.idToken, itemForCreate)
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=createMainDataFix: OK', mc.LOG_TYPE_I) : (() => { })()
          this.$emit('modalFixed')
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=createMainDataFix: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to create the data at the moment, try back later.')
      }
    },

    /* =================================================================================
     * WriteProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    WriteProcMsg (type, content) {
      if (type === 'normal') {
        this.procMsgNormal = content
        setTimeout(() => { this.procMsgNormal = null }, mc.MSG_TIMEOUT)
      } else if (type === 'attention') {
        this.procMsgAttention = content
        setTimeout(() => { this.procMsgAttention = null }, mc.MSG_TIMEOUT)
      }
    },

    /* =================================================================================
     * resetProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    resetProcMsg () {
      this.procMsgNormal = null
      this.procMsgAttention = null
    }
  },

  computed: {
    /* =================================================================================
     * tagsForAutoCompleteFiltered
     *   Val04のタグ候補から、すでに入力済みのものを除外
     * ============================================================================== */
    tagsForAutoCompleteFiltered () {
      return this.tagsForAutoComplete.filter(i => {
        return i.text.toLocaleLowerCase().indexOf(this.tag.toLocaleLowerCase()) !== -1
      })
    }
  }

}
</script>

<style scoped lang="scss">
#overlay{
  z-index: 51;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
#content{
  z-index: 52;
  max-width: 18em;
  width: 100%;
  padding: 0.5em;
  border-radius: 0.25em;
  box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.3);
  background:#fff;
}
.outline-vertical {
  display: flex;
  flex-direction: column;
}
.block-vertical {
  display: flex;
  flex-direction: column;
}
.block-horizontal {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.input-holder {
  margin: 0.25em 0;
}
.button-holder {
  margin: 0.5em 0.1em 1em 0.1em;
}
</style>
